import { useBoolean } from "@imwebme/clay-hooks";
import { TooltipProvider } from "./Tooltip.provider";
import { TooltipTrigger } from "./Tooltip.trigger";
import type { TooltipProps } from "./Tooltip.types";
import { TooltipContent } from "./TooltipContent";

const Tooltip = ({ children, initialOpened = false, onClose }: TooltipProps) => {
  const { value, toggle, setOff } = useBoolean(initialOpened);

  return (
    <TooltipProvider isOpen={value} toggle={toggle} setOff={setOff} onClose={onClose}>
      {children}
    </TooltipProvider>
  );
};

const TooltipNameSpace = Object.assign(Tooltip, {
  Trigger: TooltipTrigger,
  Content: TooltipContent,
});

export { TooltipNameSpace as Tooltip };
